import GetCookie from '../GetCookie'
import Cookie from './Cookie'
import axios from 'axios'

// ==========================================================================================
// 定数
// ==========================================================================================
const TARGET_COOKIE = '_mkto_trk'
const TOKEN = 'token:'
const API_KEY = 'hUkf4dATuqNa5n' // TODO:APIKey入れる
const ApiResponseStatus = {
  /** 正常 */
  Success: 200000
}
export const SapCdcErrorCode = {
  /** 成功 */
  Success: 0,
  /** 会員情報に不足項目あり */
  AccountPendingRegistration: 206001,
  /** 未認証の場合 */
  UnauthorizedUser: 403005
}

// ==========================================================================================
// グローバル変数
// ==========================================================================================

let targetCookieValue = ''
let tokenCookie = ''
let userInfo = {}
let uid = ''

// ==========================================================================================
// メインロジック
// ==========================================================================================
export async function callCookieSave(argUid: string) {
  // Cookie関連クラス
  const cookieClass = new GetCookie()
  const cookie = new Cookie()

  uid = argUid

  // Marketo_Cookieチェック
  targetCookieValue = cookieClass.get(TARGET_COOKIE)
  if (targetCookieValue === '') {
    // 値が取れない場合、指定したキーのcookieは存在しないため処理終了
    return
  }

  // 多重送信防止のためのMarketoチェック
  const valueItems = targetCookieValue.split('&amp;')
  tokenCookie = valueItems[1].replace(TOKEN, '')
  const multipleCookieCheck = cookieClass.get(tokenCookie)
  if (multipleCookieCheck === 'true') {
    // trueの場合送信済のため処理終了(multipleCookieCheckが取れずに空 or true以外の場合は処理続行)
    return
  }

  // リクエスト情報の作成
  createUserInfo()
  // Cookie保存APIの呼び出し
  const requestResult = await executeApi(
    drupalSettings.vueComponent.idShimadzu.domain + 'member/api/cookie_save',
    JSON.stringify(userInfo)
  )
  if (requestResult.data.status_code === ApiResponseStatus.Success) {
    cookie.setCookie(tokenCookie, 'true', 34560000)
  }

  // const requestResultTest = { status_code: 500006 } // 単体テスト用
  // if (requestResultTest.status_code === ApiResponseStatus.Success) {
  //   cookie.setCookie(tokenCookie, 'true', 34560000)
  // }
}

// ==========================================================================================
// 実行関数
// ==========================================================================================

/**
 * リスエスト用オブジェクトの作成関数
 */
function createUserInfo() {
  userInfo = {
    apiKey: API_KEY,
    UID: uid,
    cookies: targetCookieValue.replace('&amp;', '&')
  }
}

// JavaAPI実行の共通処理
export function executeApi(url: string, jsonData: string) {
  return axios.post(url, jsonData)
}
